import { PlayerEvent } from '../PlayerEvent';
import { ReactComponent as SurveyIcon } from '@crazyegginc/hatch/dist/images/icon-survey-filled.svg';

export function SurveyResponseEvent({ timestamp, active, ...rest }) {
  return <PlayerEvent icon={SurveyIcon} title="Survey response" timestamp={timestamp} active={active} {...rest} />;
}
